import Link from 'next/link'
import Image from 'next/image'

const ContactInfo = () => {
    return (
        <div itemScope itemType="https://schema.org/WebPage">
            <ul className="ipad:flex-row ipad:w-full">
                <li className="flex gap-3 mb-4">
                    <div className="h-9 w-9">
                        <Image
                            src="/fast.svg"
                            alt="fast"
                            layout="responsive"
                            width={36}
                            height={36}
                            itemProp="image"
                        />
                    </div>
                    <div className="mt-1" itemProp="email">
                        <Link href="mailto:hello@smartanswers.io">
                            <a className="ml-[4.54px] text-base font-normal">
                                hello@smartanswers.io
                            </a>
                        </Link>
                    </div>
                </li>
                <li className="flex gap-3 mb-4">
                    <div className="h-9 w-9">
                        <Image
                            src="/phone.svg"
                            alt="phone"
                            layout="responsive"
                            width={36}
                            height={36}
                            itemProp="image"
                        />
                    </div>
                    <div className="mt-1" itemProp="telephone">
                        <Link href="tel:+19252926668">
                            <a className="ml-[4.54px] text-base font-normal">
                                +1 (925) 292-6668
                            </a>
                        </Link>
                    </div>
                </li>
                <li className="flex gap-3 mb-4">
                    <div className="h-9 w-9">
                        <Image
                            src="/location.svg"
                            alt="location"
                            layout="responsive"
                            width={36}
                            height={36}
                            itemProp="image"
                        />
                    </div>
                    <div className="">
                        <p
                            className="text-base text-interface-900 font-normal ml-[4.54px]"
                            itemProp="address"
                        >
                            4695 Chabot Dr. Suite 200, Pleasanton,
                            <br /> CA 94588, USA.
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default ContactInfo
